import styled from 'styled-components';

import { Text } from '../../../../components';
import { ANIM, COLORS, SPACE } from '../../../../theme/tokens';

export const Disclosure = styled.button`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: ${COLORS.heading};
  font: inherit;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
`;

export const Chevron = styled.span<{ $open: boolean }>`
  display: inline-flex;
  color: ${COLORS.textMuted};
  transform: rotate(${(p) => (p.$open ? '0deg' : '-90deg')});
  transition: transform ${ANIM.INTERACT_MS}ms ${ANIM.EASE};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
  margin-top: ${SPACE[16]};
`;

export const ToggleRow = styled.div<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACE[12]};
  ${(p) => (p.$disabled ? 'opacity: 0.55;' : '')}
`;

export const ToggleLabel = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

export const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const HintText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.warning};
`;

export const ErrorText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.danger};
`;
